import { Data } from "effect"
import React from "react"

export interface Analytics {
  identify: (user: Analytics.User) => void

  reset: () => void

  track: (event: Analytics.Event) => void

  track_links: (query: string, event: Analytics.Event) => void
}

export namespace Analytics {
  export type User = {
    id: string
    email: string
    name: string
    authMethod: string
    createdAt: string
  }

  export const EventNames: Record<Event["_tag"], string> = {
    // Check-In
    CheckInStarted: "Check-In: Started",
    CheckInPhoneNumberSubmitted: "Check-In: Phone Number Submitted",
    CheckInConfirmed: "Check-In: Confirmed",
    MerchTapLanded: "Merch Tap: Landed",
    MerchTapStarted: "Merch Tap: Started Claim",
    MerchTapConfirmed: "Merch Tap: Confirmed",
    MerchBuyNowClicked: "Merch Buy Now: Clicked",
    ExclusiveViewed: "Exclusives: Viewed",
    ShowViewed: "Show: Viewed",
    CheckInGpsRejected: "Check-In: GPS permission rejected",
    CheckInLocationInvalid: "Check-In: Invalid location",
    ExclusiveVideoPlayed: "Exclusive Video: Played",
  }

  export type Event = Data.TaggedEnum<{
    CheckInStarted: { showId: string }
    CheckInPhoneNumberSubmitted: { showId: string }
    CheckInConfirmed: { showId: string }
    MerchTapLanded: {
      merchSkuId: string
      merchItemId: string
      status: "Unknown" | "Unclaimed" | "Claimed"
    }
    MerchTapStarted: { merchSkuId: string; merchItemId: string }
    MerchTapConfirmed: { merchSkuId: string; merchItemId: string }
    MerchBuyNowClicked: { merchSkuId: string }
    ExclusiveViewed: { exclusiveId: string }
    ShowViewed: { showId: string; showDate: string }
    CheckInGpsRejected: { error: string }
    CheckInLocationInvalid: { showId: string }
    ExclusiveVideoPlayed: { exclusiveId: string }
  }>

  export const Event = Data.taggedEnum<Event>()
}

export const AnalyticsContext = React.createContext<Analytics | null>(null)

export const consoleAnalytics: Analytics = {
  identify: (user) => console.log("Analytics.identify", user),
  reset: () => console.log("Analytics.reset"),
  track: (event) => {
    const { _tag, ...rest } = event
    console.log("Analytics.track", { event: Analytics.EventNames[_tag], ...rest })
  },
  track_links: (query, event) => {
    const { _tag, ...rest } = event
    console.log("Analytics.track_links", {
      query,
      event: Analytics.EventNames[_tag],
      ...rest,
    })
  },
}

export const useAnalytics = () => {
  const analytics = React.useContext(AnalyticsContext)

  if (!analytics) {
    throw new Error("useAnalytics must be used within a AnalyticsProvider")
  }

  return analytics
}
